import Vue from "vue";
import Vuex, { mapActions } from "vuex";
import VuexPersistence from "vuex-persist";
import qs from "qs";

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    projectName: null,

    token: null,

    duty: null,

    sceneSetting: null,

    moduleConfig: null,
  },

  getters: {
    token(state) {
      return state.token;
    },

    duty(state) {
      return state.duty;
    },

    isUserInRole: (state) => (rolenames) => {
      if (!state.token?.roles || !Array.isArray(state.token?.roles))
        return false;
      if (Array.isArray(rolenames)) {
        return rolenames.some((rolename) => {
          return state.token.roles.includes(rolename);
        });
      } else {
        return state.token.roles.includes(rolenames);
      }
    },

    /**
     * 公用方法
     */
    termInitDate: () => (term) => {
      if (term == null) return null;

      return new Date(term.createTime);
      // let date;
      // if (term.termType === "First") {
      //   date = new Date(term.year, 8, 1);
      // } else if (term.termType === "Second") {
      //   date = new Date(term.year + 1, 2, 1);
      // }
      // return date;
    },

    formatClazzName: (state) => (clazz) => {
      return `${clazz.year}级${parseInt(clazz.name).toLocaleString(undefined, {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })}班`;
    },

    formatSeqNo: (state) => (seqNo) => {
      return parseInt(seqNo).toLocaleString(undefined, {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    },

    formatFraction:
      (state) =>
      (num, maximumFractionDigits = 2, minimumFractionDigits) => {
        if (!num) return "";
        return num.toLocaleString(undefined, {
          maximumFractionDigits,
          minimumFractionDigits,
          useGrouping: false,
        });
      },

    formatPercent:
      (state) =>
      (num, maximumFractionDigits = 2) => {
        if (isNaN(num)) return "";
        if (!num && typeof num !== "number") return "";
        return num.toLocaleString(undefined, {
          style: "percent",
          maximumFractionDigits: maximumFractionDigits,
          // minimumFractionDigits: 2,
        });
      },

    formatTermName: (state) => (term) => {
      return `${term.year}年${term.termType === "First" ? "上" : "下"}学期`;
    },

    getCurrentLeavePeriod: () => {
      // return "Afternoon";
      const now = new Date();

      if (now.getHours() < 12) {
        return "Forenoon";
      } else {
        return "Afternoon";
      }
    },

    gradeYearOptions: () => {
      let options = [];
      const currentYear = new Date().getFullYear();
      for (let i = 2019; i <= currentYear; i++) {
        options.push(i);
      }
      return options;
    },

    intToChinese: (state) => (num) => {
      const arr1 = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      const arr2 = [
        "",
        "十",
        "百",
        "千",
        "万",
        "十",
        "百",
        "千",
        "亿",
        "十",
        "百",
        "千",
        "万",
        "十",
        "百",
        "千",
        "亿",
      ];
      if (!num || isNaN(num)) return "零";
      const numStr = num.toString().split("");
      let result = "";
      for (let i = 0; i < numStr.length; i++) {
        const des_i = numStr.length - 1 - i;
        result = arr2[i] + result;
        const arr1_index = numStr[des_i];
        result = arr1[arr1_index] + result;
      }
      result = result.replace(/零(千|百|十)/g, "零").replace(/十零/g, "十");
      result = result.replace(/零+/g, "零");
      result = result.replace(/零亿/g, "亿").replace(/零万/g, "万");
      result = result.replace(/亿万/g, "亿");
      result = result.replace(/零+$/, "");
      result = result.replace(/^一十/g, "十");
      return result;
    },
  },

  mutations: {
    afterLogin(state) {
      state.token = JSON.parse(window.localStorage.getItem("token"));
      let str = window.localStorage.getItem("sceneSetting");

      let sceneSetting;
      if (str) {
        sceneSetting = JSON.parse(str);
        state.sceneSetting = sceneSetting;
      }
    },

    chooseDuty(state, duty) {
      state.duty = Object.assign(duty, {
        dutyType: duty.clazz ? "ClazzDuty" : "GradeDuty",
      });
      window.localStorage.setItem("duty", duty);
    },

    clearDuty(state) {
      state.duty = null;
      window.localStorage.removeItem("duty");
    },

    logout({ dispatch }) {
      sessionStorage.removeItem("token");
      localStorage.removeItem("token");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      dispatch("clearDuty");
      Reflect.deleteProperty(
        this.axios.defaults.headers.common,
        "Authorization"
      );
    },

    setProjectName(state, projectName) {
      state.projectName = projectName;
    },

    setSceneSetting(state, sceneSetting) {
      state.sceneSetting = sceneSetting;
    },

    setModuleConfig(state, moduleConfig) {
      state.moduleConfig = moduleConfig;
    },
  },

  actions: {
    // 延迟器
    delay: async function ({}, ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    findEntity: async function ({}, url) {
      let res = await Vue.axios.get(url);
      return res.data;
    },

    findEntities: async function ({}, { url = "", params = {} }) {
      let res = await Vue.axios.get(url, {
        params,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      return res.data;
    },

    findAllEntities: async function ({ dispatch }, { url = "", params = {} }) {
      let dataTable,
        page = 0,
        datas = [];
      do {
        dataTable = await dispatch("findEntities", {
          url,
          params: {
            ...params,
            page,
          },
        });
        page++;
        datas.push(...dataTable.content);
      } while (!dataTable.last);
      return datas;
    },

    // findAllEntities: async function ({}, { url, params = {} }) {
    //   if (!url) throw new Error("url无效");
    //   let dataTable,
    //     page = 0,
    //     datas = [];
    //   do {
    //     let res = await Vue.axios.get(url, {
    //       params: {
    //         ...params,
    //         page,
    //       },
    //     });
    //     dataTable = res.data;
    //     datas.push(...dataTable.content);
    //     page++;
    //   } while (!dataTable.last);
    //   return datas;
    // },

    getProjectName: async function ({ commit, state }) {
      // return "一二年级“乐考”评价管理平台";
      return await new Promise((resolve, reject) => {
        Vue.axios
          .get(`/api/configs/project-name`)
          .then((res) => {
            commit("setProjectName", res.data);
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    queryOrgName: async function ({ state, commit }) {
      let res = await Vue.axios.get(`/api/configs/organization-name`);
      return res.data;
    },

    getModuleConfig: async function ({ commit, state }) {
      return await new Promise((resolve, reject) => {
        if (state.moduleConfig) {
          resolve(state.moduleConfig);
        } else {
          Vue.axios
            .get(`/api/config/modules`)
            .then((res) => {
              commit("setModuleConfig", res.data);
              resolve(res.data);
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },

    queryDimensions: async function ({}) {
      let res = await Vue.axios.get(`/api/courses/dimensions`);
      return res.data;
    },

    queryAssessmentSources: async function ({}) {
      let res = await Vue.axios.get(`/api/enums/assessment-sources`);
      return res.data;
    },

    queryLeaveTypes: async function () {
      let res = await Vue.axios.get(`/api/enums/leave-types`);
      return res.data;
    },

    queryLeavePeriods: async function () {
      let res = await Vue.axios.get(`/api/enums/leave-periods`);
      return res.data;
    },

    queryInfectiousTypes: async function () {
      let res = await Vue.axios.get(`/api/enums/infectious-types`);
      return res.data;
    },

    findCurrentTerm: async function ({}) {
      let res = await Vue.axios.get(`/api/terms/query/current`);
      return res.data;
    },

    findTerm: async function ({}, id) {
      let res = await Vue.axios.get(`/api/terms/${id}`);
      return res.data;
    },

    findTerms: async function () {
      let res,
        page = 0,
        datas = [];
      do {
        res = await Vue.axios.get(`/api/terms`, {
          params: {
            page,
          },
        });
        datas.push(...res.data.content);
        page++;
      } while (!res.data.last);

      return datas;
    },

    findClazzes: async function ({}, params = { page: 0, size: 10 }) {
      let res = await Vue.axios.get(`/api/clazzes`, {
        params,

        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      return res.data;
    },

    findAllClazzes: async function ({ dispatch }, params = {}) {
      let dataTable,
        datas = [],
        page = 0;
      do {
        dataTable = await dispatch(
          "findClazzes",
          Object.assign(params, {
            page,
          })
        );
        datas.push(...dataTable.content);
        page++;
      } while (!dataTable.last);

      return datas.sort((c1, c2) => {
        if (c1.year !== c2.year) return c1.year - c2.year;
        return parseInt(c1.name) - parseInt(c2.name);
      });
    },

    findInUseClazzes: async function ({}) {
      let res = await Vue.axios.get(`/api/clazzes/in-use`);
      return res.data.sort((c1, c2) => {
        if (c1.year === c2.year) return parseInt(c1.name) - parseInt(c2.name);
        return c1.year - c2.year;
      });
    },

    findClazz: async function ({}, id) {
      let res = await Vue.axios.get(`/api/clazzes/${id}`);
      return res.data;
    },

    findStudentsByClazzId: async function ({}, clazzId) {
      let res,
        page = 0,
        datas = [];
      do {
        res = await Vue.axios.get(`/api/students`, {
          params: {
            page,
            clazzId,
            sort: "seqNo,asc",
          },
        });
        page++;
        datas.push(...res.data.content);
      } while (!res.data.last);
      return datas;
    },

    findStudentByClazzAndName: async function ({}, { clazzId, name }) {
      let res = await Vue.axios.get(`/api/students`, {
        params: {
          clazzId,
          name,
        },
      });
      if (res.data.totalElements > 0) {
        return res.data.content[0];
      }
      throw new Error();
    },

    findStudent: async function ({}, id) {
      let res = await Vue.axios.get(`/api/students/${id}`);
      return res.data;
    },

    findTeacherDuties: async function ({}, params = {}) {
      let res = await Vue.axios.get(`/api/teacher-duties`, {
        params,

        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      return res.data;
    },

    findAllTeacherDuties: async function ({ dispatch }, params = {}) {
      let dataTable,
        page = 0,
        datas = [];
      do {
        dataTable = await dispatch("findTeacherDuties", {
          ...params,
          page,
        });
        page++;
        datas.push(...dataTable.content);
      } while (!dataTable.last);
      return datas;
    },

    findTeacherDutiesOfTerm: async function ({}, termId) {
      let res,
        page = 0,
        datas = [];
      do {
        res = await Vue.axios.get(`/api/teacher-duties`, {
          params: {
            page,
            termId,
            size: 200,
          },
        });
        page++;
        datas.push(...res.data.content);
      } while (!res.data.last);
      return datas;
    },

    findReportCards: async function ({}, params = {}) {
      let res = await Vue.axios.get(`/api/report-cards`, {
        params,
      });
      return res.data;
    },

    findAllReportCards: async function ({ dispatch }, params = {}) {
      let dataTable,
        page = 0,
        datas = [];

      do {
        dataTable = await dispatch(
          "findReportCards",
          Object.assign({}, params, {
            page,
          })
        );
        datas.push(...dataTable.content);
        page++;
      } while (!dataTable.last);

      return datas;
    },

    findSchoolReportCards: async function ({}, { termId, year, month }) {
      let res,
        page = 0,
        datas = [];
      do {
        res = await Vue.axios.get(`/api/school-report-cards`, {
          params: {
            page,
            termId,
            year,
            month,
          },
        });
        page++;
        datas.push(...res.data.content);
      } while (!res.data.last);
      return datas;
    },

    findGradeReportCards: async function ({}, { termId, year, month }) {
      let res,
        page = 0,
        datas = [];
      do {
        res = await Vue.axios.get(`/api/grade-report-cards`, {
          params: {
            page,
            termId,
            year,
            month,
          },
        });
        page++;
        datas.push(...res.data.content);
      } while (!res.data.last);
      return datas;
    },

    findCourses: async function () {
      let res,
        datas = [];
      res = await Vue.axios.get(`/api/courses`);
      datas.push(...res.data);
      return datas;
    },

    findCourseGoals: async function ({}, params = {}) {
      let res = await Vue.axios.get(`/api/course-goals`, {
        params,
      });
      return res.data;
    },

    findAllCourseGoals: async function ({ dispatch }, params = {}) {
      let dataTable,
        page = 0,
        datas = [];
      do {
        dataTable = await dispatch("findCourseGoals", {
          ...params,
          page,
        });
        page++;
        datas.push(...dataTable.content);
      } while (!dataTable.last);
      return datas;
    },

    findUserByUsername: async function ({}, username) {
      let res = await Vue.axios.get(`/api/users/username/${username}`);
      return res.data;
    },

    findLeaveRecords: async function ({}, { date, clazzId }) {
      let res,
        datas = [],
        page = 0;
      do {
        res = await Vue.axios.get(`/api/leave-records`, {
          params: {
            date,
            clazzId,
            page,
          },

          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        });
        datas.push(...res.data.content);
        page++;
      } while (!res.data.last);

      return datas;
    },

    findAllHospitals: async function () {
      let res,
        page = 0,
        datas = [];
      do {
        res = await Vue.axios.get(`/api/hospitals`, {
          params: {
            page,
          },
        });
        datas.push(...res.data.content);
        page++;
      } while (!res.data.last);

      return datas;
    },

    findCourseItems: async function () {
      let res,
        datas = [];
      res = await Vue.axios.get(`/api/course-items`);
      datas.push(...res.data);
      datas.reverse();
      return datas;
    },

    findCourseItemGoals: async function () {
      let res,
        datas = [];
      res = await Vue.axios.get(`/api/course-item-goals`);
      datas.push(...res.data);
      return datas;
    },

    findLastCourseItemPlaceConfig: async function ({}) {
      let res = await Vue.axios.get(`/api/course-item-place-configs`, {
        params: {
          size: 1,
          sort: "id,desc",
        },
      });
      const dataTable = res.data;
      if (dataTable.empty) {
        throw new Error("无可用地图配置信息，请联系管理员");
      }
      return dataTable.content[0];
    },

    findCourseItemPlaceConfigs: async function ({}, params = {}) {
      let res = await Vue.axios.get(`/api/course-item-place-configs`, {
        params,
      });
      return res.data;
    },

    findAllCourseItemPlaceConfigs: async function ({ dispatch }, params = {}) {
      let dataTable,
        datas = [],
        page = 0;
      do {
        dataTable = await dispatch(
          "findCourseItemPlaceConfigs",
          Object.assign(params, {
            page,
          })
        );
        datas.push(...dataTable.content);
        page++;
      } while (!dataTable.last);

      return datas;
    },

    findCourseItemPlaceConfig: async function ({}, id) {
      let res = await Vue.axios.get(`/api/course-item-place-configs/${id}`);
      return res.data;
    },

    findCourseItemPlaces: async function ({}, id) {
      let res = await Vue.axios.get(`/api/course-item-places/config/${id}`);
      return res.data;
    },

    findBatch: async function ({}, id) {
      let res = await Vue.axios.get(`/api/batches/${id}`);
      return res.data;
    },

    findBatchGoals: async function ({}, batchId) {
      let res = await Vue.axios.get(`/api/batch-goals/batch/${batchId}`);
      return res.data;
    },

    findExamRecords: async function ({}, params = { page: 0, size: 10 }) {
      let res = await Vue.axios.get(`/api/exam-records`, {
        params,
      });
      return res.data;
    },

    findAllExamRecords: async function ({ dispatch }, params = {}) {
      let dataTable,
        datas = [],
        page = 0;
      do {
        dataTable = await dispatch(
          "findExamRecords",
          Object.assign(params, {
            page,
          })
        );
        datas.push(...dataTable.content);
        page++;
      } while (!dataTable.last);

      return datas;
    },

    statExamRecordByGrade: async function ({}, [batchId, params = {}]) {
      let res = await Vue.axios.get(`/api/exam/stats/${batchId}/by-grade`, {
        params,
      });
      return res.data;
    },

    statExamRecordByClazz: async function ({}, [batchId, params = {}]) {
      let res = await Vue.axios.get(`/api/exam/stats/${batchId}/by-clazz`, {
        params,
      });
      return res.data;
    },

    findIndicators: async function ({}, params = {}) {
      let res = await Vue.axios.get(`/api/review/indicators`, {
        params,
      });
      return res.data;
    },

    findExamPaper: async function ({}, id) {
      let res = await Vue.axios.get(`/api/review/exam-papers/${id}`);
      return res.data;
    },

    findExamQuestionsByExamPaperId: async function ({}, examPaperId) {
      let res = await Vue.axios.get(
        `/api/review/exam-questions/exam-paper/${examPaperId}`
      );
      return res.data;
    },

    findExamQuestion: async function ({}, id) {
      let res = await Vue.axios.get(`/api/review/exam-questions/${id}`);
      return res.data;
    },

    findIndicatorSnapshotsByExamPaperId: async function ({}, examPaperId) {
      let res = await Vue.axios.get(
        `/api/review/indicator-snapshots/exam-paper/${examPaperId}`
      );
      return res.data;
    },

    findReviewExamRecords: async function ({}, params = {}) {
      let res = await Vue.axios.get(`/api/review/exam-records`, {
        params,
      });
      return res.data;
    },

    findAllReviewExamRecords: async function ({ dispatch }, params = {}) {
      let dataTable,
        datas = [],
        page = 0;
      do {
        dataTable = await dispatch(
          "findReviewExamRecords",
          Object.assign(params, {
            page,
          })
        );
        datas.push(...dataTable.content);
        page++;
      } while (!dataTable.last);

      return datas;
    },

    findAllSimpleReviewExamRecords: async function ({ dispatch }, params = {}) {
      let dataTable,
        datas = [],
        page = 0;
      do {
        let res = await Vue.axios.get(
          "/api/review/exam-records/simple/entities",
          {
            params: Object.assign(params, {
              page,
            }),
          }
        );
        dataTable = res.data;
        datas.push(...dataTable.content);
        page++;
      } while (!dataTable.last);

      return datas;
    },

    findIndicatorSnapshotQualifiedScore: async function (
      {},
      params = {
        examPaperId: 0,
        clazzId: 0,
      }
    ) {
      let res = await Vue.axios.get(
        `/api/review/indicator-snapshots/qualified-score/exam-paper/${params.examPaperId}/clazz/${params.clazzId}`
      );
      let datas = res.data;
      return datas.reduce((t, d) => {
        return {
          ...t,
          [d.indicatorId]: d.score,
        };
      }, {});
    },
  },

  modules: {},

  plugins: [vuexLocal.plugin],
});
